import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import * as images from '@/assets/img';

import { StaticContentText, StaticContentTitle } from '../StaticContent.styles';

import { Image, Step, Wrapper } from './List.styles';

export function List({ id, length = 3 }) {
  const { formatMessage } = useIntl();

  return (
    <Wrapper id={id} className="sections">
      <StaticContentTitle as="h2">
        {formatMessage({
          id: `staticContent.anchorLinks.map.title.${id}`,
        })}
      </StaticContentTitle>

      {Array.from({ length }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Step key={index}>
          <Image src={images[`${id}${index + 1}`]} />

          <StaticContentText>
            {formatMessage(
              {
                id: `staticContent.${id}.${index}`,
              },
              { br: <br /> }
            )}
          </StaticContentText>
        </Step>
      ))}
    </Wrapper>
  );
}

List.propTypes = {
  id: PropTypes.string.isRequired,
  length: PropTypes.number,
};

export default memo(List);
